import React from 'react';
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor';
import {Tooltip} from 'wix-ui-tpa';
import {useControllerProps} from '../../../../../../../domain/controllers/ControllerContext';
import {OrderSummaryDataHook} from '../../OrderSummary';
import {DestinationPicker} from '../DestinationPicker/DestinationPicker';
import s from './EstimatedTax.scss';

export const EstimatedTax = () => {
  const {t} = useTranslation();
  const {shouldDisplayTaxDestinationPicker, taxName: taxNameOld} = useControllerProps().orderStore;
  const {moveCartToViewerContext} = useControllerProps().cartStore;
  const {
    priceSummary: {
      tax: {formattedConvertedAmount},
    },
    taxSummary: {taxName},
  } = useControllerProps().cartStore.cartSummary;
  const {isMobile, isRTL} = useEnvironment();
  const pointToMove = isRTL ? /* istanbul ignore next */ {x: -60, y: 0} : {x: 60, y: 0};
  const taxNameToRender = moveCartToViewerContext
    ? taxName || t('cart.estimated_tax')
    : taxNameOld || t('cart.estimated_tax');

  return (
    <div data-hook={OrderSummaryDataHook.EstimatedTaxRoot}>
      <dl>
        <dt>
          <div data-hook={OrderSummaryDataHook.EstimatedTax}>
            <span data-hook={OrderSummaryDataHook.EstimatedTaxTaxName}>{taxNameToRender}</span>
            &nbsp;
            <Tooltip
              moveBy={isMobile ? /* istanbul ignore next */ pointToMove : {x: 0, y: 0}}
              content={t('cart.tooltips.estimated_tax_message')}
              placement="top"
              minWidth={200}
              maxWidth={250}>
              <span className={s.info}>?</span>
            </Tooltip>
            {shouldDisplayTaxDestinationPicker && (
              <DestinationPicker dataHook={OrderSummaryDataHook.TaxDestinationPickerRoot} />
            )}
          </div>
        </dt>
        <dd
          data-hook={OrderSummaryDataHook.EstimatedTaxEstimatedTaxPrice}
          data-wix-estimated-tax-price={OrderSummaryDataHook.EstimatedTaxEstimatedTaxPrice}>
          {formattedConvertedAmount}
        </dd>
      </dl>
    </div>
  );
};
